import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const SitemapPage = () => {
  const links = [
    { label: 'Home', href: '/' },
    { label: 'Contato', href: '/contato' },
    { label: 'Sistema ERP', href: '/sistema-erp' },
    { label: 'App Vendas', href: '/app-vendas' },
    { label: 'PDV', href: '/sistema-pdv' },
    { label: 'Casos de Sucesso', href: '/casos-sucesso' },
    { label: 'Planos', href: '/planos' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Suporte', href: '/suporte' },
    { label: 'Blog', href: '/blog' },
    { label: 'Materiais', href: '/materiais' },
    { label: 'Demonstração', href: '/demonstracao' },
    { label: 'Especialista', href: '/especialista' },
    { label: 'Privacidade', href: '/privacidade' },
    { label: 'Termos', href: '/termos' }
  ];

  return (
    <div>
      <PageHero
        eyebrow="Mapa do site"
        title="Navegue por todas as páginas."
        subtitle="Links organizados para facilitar sua jornada."
        primaryCta={{ label: 'Ir para Home', href: '/' }}
      />
      <section className="bg-white text-slate-900">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Links"
            title="Páginas disponíveis"
            description="Estrutura completa do site Zartoo."
            mode="light"
          />
          <Card variant="light">
            <ul className="grid md:grid-cols-2 gap-3 text-slate-700">
              {links.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-[#1976D2] font-semibold hover:underline">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default SitemapPage;
